import { inject, Injectable } from '@angular/core';
import { DataTestService } from '@y42/data-test';
import { DatasourceTableStoreModel } from '@y42/datasource';
import { UiModelingTableService } from '../datasource-table';

@Injectable({ providedIn: 'root' })
export class UiModelingDataTestService extends DataTestService<DatasourceTableStoreModel> {
  constructor() {
    super(inject(UiModelingTableService));
  }
}
